import { useEffect } from 'react';
import { Typography, Container } from '@mui/material';

const PageError = ({ title, message, message2 }) => {

    useEffect(() => {
        document.title = title;
    }, [title]);

    return (
        <Container sx={{ mt: 6 }}>
            <Typography variant="h1" align="center">
                {title}
            </Typography>
            <Typography variant="body1" align="center" sx={{ mt: 2 }}>
                {message}
            </Typography>
            {message2 && (
                <Typography variant="body2" color="text.secondary" align="center">
                    {message2}
                </Typography>
            )}
        </Container>
    );
};

export default PageError;
